import React, { useContext } from "react";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import DnsRoundedIcon from "@mui/icons-material/DnsRounded";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Collapse } from "@mui/material";
import { Stack } from "@mui/system";
import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import NavItem from "./NavItem";
import { sidebar } from "../../theme";

const Security = ({ drawerIsOpen }) => {
  const [open, setOpen] = React.useState(false);
  const { access } = useContext(DataContext);
  let rout = getRuta();
  return isAccess(access, "SECURITY VER") ? (
    <div>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "10px 14px",
          borderRadius: "9px",
          cursor: "pointer",
          color: sidebar.itemColor,
          marginBottom: "2px",
          "&:hover": { backgroundColor: "rgba(255,255,255,.06)", color: "#e8edf3" },
        }}
      >
        <Box sx={{ display: "flex", color: sidebar.iconColor, fontSize: 20 }}>
          <ShieldRoundedIcon fontSize="inherit" />
        </Box>
        <Box component="span" sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
          Seguridad
        </Box>
        {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Stack paddingLeft={drawerIsOpen ? 1.5 : 0} spacing={0.2}>
          <NavItem sub to={`${rout}/users`} icon={<ManageAccountsRoundedIcon fontSize="inherit" />} label="Usuarios" />
          <NavItem sub to={`${rout}/rols`} icon={<AdminPanelSettingsRoundedIcon fontSize="inherit" />} label="Roles" />
          <NavItem sub to={`${rout}/server`} icon={<DnsRoundedIcon fontSize="inherit" />} label="Servidor" />
        </Stack>
      </Collapse>
    </div>
  ) : (
    <></>
  );
};

export default Security;
